/* New Design - PageHeader Component */

import React from 'react';
import PropTypes from 'prop-types';
import style from './PageHeader.module.css';

const PageHeader = ({
  title,
  subTitle,
  titleBadge,
  flushSubTitle,
  primarySubTitle,
  regularWeightSubTitle,
  children,
}) => {
  return (
    <div className={style.pageHeader}>
      <div>
        {titleBadge ? (
          <div className={style.titleRow}>
            <h1 className={style.pageTitle}>{title}</h1>
            {titleBadge}
          </div>
        ) : (
          <h1 className={style.pageTitle}>{title}</h1>
        )}
        <span
          className={`${style.subTitle}${flushSubTitle ? ` ${style.subTitleFlush}` : ''}${primarySubTitle ? ` ${style.subTitlePrimary}` : ''}${regularWeightSubTitle ? ` ${style.subTitleRegular}` : ''}`}
        >
          {subTitle}
        </span>
      </div>
      <div className={style.rightChildren}>{children}</div>
    </div>
  );
};

PageHeader.propTypes = {
  title: PropTypes.string,
  subTitle: PropTypes.node,
  titleBadge: PropTypes.node,
  // When true, aligns the subtitle flush-left with the title (drops the legacy
  // 10px indent). Opt-in so existing pages are unaffected.
  flushSubTitle: PropTypes.bool,
  // When true, renders the subtitle in the meet-page primary style: flush-left
  // with the title, title color, semibold. For pages whose subtitle is a single
  // primary label (e.g. a season name) rather than a muted annotation.
  primarySubTitle: PropTypes.bool,
  // When true, forces regular font weight. Combine with primarySubTitle for
  // settings pages: primary placement/color without the semibold.
  regularWeightSubTitle: PropTypes.bool,
  children: PropTypes.node,
};

export default PageHeader;
